import { COLORS } from '@Commons';
import styled from 'styled-components';

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
`;

export const StyledInput = styled.input`
  width: 100%;
  padding: 8px 100px 8px 0;
  border: none;
  border-bottom: 1px solid ${COLORS.disabled};
  outline: none;
  font-size: 16px;
  transition: border-bottom-color 0.3s ease;

  &::placeholder {
    color: ${COLORS.disabled};
    text-transform: none;
  }

  &:focus {
    border-bottom-color: ${COLORS.black};
  }
`;

export const ButtonContainer = styled.span`
  position: absolute;
  right: 0;
  padding: 8px 0 16px 8px;
`;
